import icon from 'vue-svgicon';

icon.register({
    'regular/house-garage': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 22.825h22.5M2.25 9.325h19.5v13.5H2.25z"/><path pid="1" d="M23.25 7.525a.752.752 0 0 0-.4-.662l-10.5-5.6a.754.754 0 0 0-.706 0l-10.5 5.6a.752.752 0 0 0-.4.662v1.05a.75.75 0 0 0 .75.75h21a.75.75 0 0 0 .75-.75zM5.25 12.325h13.5v10.5H5.25zM8.25 16.825h7.5M8.25 19.825h7.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
